export default __webpack_public_path__ + "static/media/thedriven.7b932b5f.svg";